import {secured as axios} from "../../../axios";

export class Notification {

    static findAll(page=1, limit=30){
        return axios.get('notifications', {params: { page, limit }}).then( res => res.data)
    }

    static markAsReaded(notificationIds){
        return axios.post('notifications/read', {
            notificationIds
        })
    }
}